module.exports = __webpack_public_path__ + "static/media/296.b54203f0.webp";